"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.uniqBy = void 0;
require("../../core");
const uniqBy = (arr, predicate) => {
    return [
        ...arr
            .reduce((map, item) => {
            const key = item === null || item === undefined ? item : item[predicate];
            map.has(key) || map.set(key, item);
            return map;
        }, new Map())
            .values(),
    ];
};
exports.uniqBy = uniqBy;
//# sourceMappingURL=uniqBy.js.map